import React from 'react';
import { Store, Clock, Heart } from 'lucide-react';
import { STORE_INFO } from '../constants';

export default function AboutUs() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-8">About {STORE_INFO.name}</h2>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <img
              src="https://images.unsplash.com/photo-1596040033229-a9821ebd058d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80"
              alt="Store Front"
              className="rounded-lg shadow-md"
            />
          </div>
          <div className="space-y-6">
            <p className="text-gray-600 leading-relaxed">
              At {STORE_INFO.name}, we take pride in bringing you the finest selection of Indian groceries, spices, and authentic ingredients. Our mission is to make Indian cooking accessible and enjoyable for everyone, while maintaining the highest standards of quality and service.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm">
                <Store className="text-[#568203] mb-2" size={24} />
                <h3 className="font-semibold">Premium</h3>
                <p className="text-sm text-gray-500">Selection</p>
              </div>
              <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm">
                <Clock className="text-[#568203] mb-2" size={24} />
                <h3 className="font-semibold">{STORE_INFO.daysOpen}</h3>
                <p className="text-sm text-gray-500">Open</p>
              </div>
              <div className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm">
                <Heart className="text-[#568203] mb-2" size={24} />
                <h3 className="font-semibold">Customer</h3>
                <p className="text-sm text-gray-500">Focused</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}